import React from 'react';
import BsImages from '../icons/BsImages';
import BiChevronRight from '../icons/BiChevronRight';
import { DateTime } from 'luxon';
import { Link } from 'react-router-dom';
import { bool, number, oneOfType, string } from 'prop-types';
import ResponsiveImage from './ResponsiveImage';
import constants from '../constants.json' assert { type: 'json' };
import useDynamicPath from '../hooks/useDynamicPath';

export default function ArticleListItem({ isPage, isMobile, title, bodyHtml, imageUrl, handle, articleWidth, author, createdAt }) {
    const articlePath = useDynamicPath({ pathName: constants.DYNAMIC_PATHS.ARTICLE_PATH });
    const articleBasePath = articlePath[0].pathBeforeParams;

    return (<li
        className={'article-list--item'}
        style={{
            ...(isMobile === true && !isPage) && ({ width: `calc(${articleWidth}% - 15px)` }),
        }}
    >
        <Link
            to={`${articleBasePath}/${handle}`}>
            {imageUrl && (<figure
                className={'article-list-item--image'}
                data-article-item-image><ResponsiveImage
                    imageUrl={imageUrl}
                    imageAlt={title || ''}
                    mobileSize={'200px'}
                    desktopSize={'200px'}></ResponsiveImage></figure>)}
            {!imageUrl && (<div
                className={'article-list-item--image'}>
                <BsImages
                    style={{ maxWidth: '150px' }} />
            </div>)}
        </Link>
        <div
            className={'article-list-item--description'}>
            <div
                className={'article-list-item--meta'}>
                <span
                    className={'article-list-item--meta-item'}>{DateTime.fromISO(createdAt).toLocaleString(DateTime.DATE_FULL)}</span>
                <span
                    className={'article-list-item--meta-item'}>{author}</span>
            </div>
            <h2
                className={'home-heading article-list-item--title'}
                style={{ marginTop: '0' }}><Link
                    to={`${articleBasePath}/${handle}`}>{title}</Link></h2>
            <p
                className={'article-list-item--description-text'}>{bodyHtml}</p>
            <Link
                className={'article-list-item--read-more'}
                to={`${articleBasePath}/${handle}`}>Read now <BiChevronRight
                    size={'15px'} /></Link>
        </div>
    </li>);
}

ArticleListItem.propTypes = {
    isPage: bool,
    isMobile: bool,
    title: string,
    bodyHtml: string,
    imageUrl: string,
    handle: string,
    articleWidth: oneOfType([number, string]),
    author: string,
    createdAt: string,
};